<template>
  <Select
    v-if="isLegalEntityFilterVisible"
    v-model="selectedLegalEntityId"
    :options="options"
    class="min-w-48"
    :aria-label="t('legalEntity')"
    data-testid="legal-entity-filter"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Select from '@/components/Select.vue';
import { useLegalEntityFilter } from '@/hooks/use-legal-entity-filter';

/** Global legal entity filter; the selection is shared across pages and kept across reloads. */
const { t } = useI18n();
const { legalEntityId, legalEntityOptions, isLegalEntityFilterVisible } = useLegalEntityFilter();

const ALL = '';
const options = computed(() => [
  { label: t('allLegalEntities'), value: ALL },
  ...legalEntityOptions.value,
]);

const selectedLegalEntityId = computed({
  get: () => legalEntityId.value ?? ALL,
  set: (value: string | null) => {
    legalEntityId.value = value || null;
  },
});
</script>

<i18n lang="json">
{
  "en": { "legalEntity": "Legal entity", "allLegalEntities": "All legal entities" },
  "de": { "legalEntity": "Gesellschaft", "allLegalEntities": "Alle Gesellschaften" },
  "es": { "legalEntity": "Sociedad", "allLegalEntities": "Todas las sociedades" }
}
</i18n>
